import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobPipelineMetrics } from "@/types";

export function useGetJobPipelineMetrics({
  companyId,
  jobId,
}: {
  companyId: string;
  jobId: string;
}) {
  return useQuery({
    queryKey: ["job-pipeline-metrics", companyId, jobId],
    queryFn: async () => {
      const path = `companies/${companyId}/jobs/${jobId}/pipeline-metrics`;
      const res = await guacHttpClient.get<
        JobPipelineMetrics,
        HttpResponse<JobPipelineMetrics>
      >(path);
      return res.data;
    },
  });
}
